import { render } from "./ImageGroups.vue?vue&type=template&id=197874ac&scoped=true"
import script from "./ImageGroups.vue?vue&type=script&lang=ts"
export * from "./ImageGroups.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-197874ac"

export default script